import { merchantNotificationService, queryService } from './api'

export const notificationService = {
  async sendBulkNotification(params: {
    targetType: 'ALL' | 'LOCATION' | 'INTERESTS' | 'CUSTOM'
    locations?: string[]
    interests?: string[]
    userIds?: string[]
    title: string
    body: string
    data?: Record<string, any>
  }) {
    let targetUserIds: string[] = []

    if (params.targetType === 'ALL') {
      const { userService } = await import('./api')
      const users = await userService.list()
      targetUserIds = users.filter((u: any) => !u.isDeactivated).map((u: any) => u.id)
    } else if (params.targetType === 'LOCATION' && params.locations) {
      const { userService } = await import('./api')
      const users = await userService.list()
      targetUserIds = users
        .filter((u: any) => !u.isDeactivated && params.locations?.some((loc: string) => u.address?.address?.includes(loc)))
        .map((u: any) => u.id)
    } else if (params.targetType === 'INTERESTS' && params.interests) {
      const { userService } = await import('./api')
      const users = await userService.list()
      targetUserIds = users
        .filter((u: any) => !u.isDeactivated && u.interests?.some((i: string) => params.interests?.includes(i)))
        .map((u: any) => u.id)
    } else if (params.targetType === 'CUSTOM' && params.userIds) {
      targetUserIds = params.userIds
    }

    if (targetUserIds.length === 0) {
      throw new Error('No users found matching criteria')
    }

    return await queryService.bulkNotificationProcessor({
      userIds: targetUserIds,
      pushTitle: params.title,
      pushBody: params.body,
      pushData: params.data ? JSON.stringify(params.data) : undefined,
      createDbRecord: true,
      notificationType: 'ADMIN_BROADCAST'
    })
  },

  async getMerchantNotifications(merchantId: string) {
    return await merchantNotificationService.listByMerchant(merchantId)
  },

  async markAsRead(notificationId: string) {
    return await merchantNotificationService.markAsRead(notificationId)
  }
}